"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieStorage = void 0;
var typescript_collections_1 = require("typescript-collections");
var Utils_1 = require("../Utils");
var CookieStorage = /** @class */ (function () {
    function CookieStorage() {
        this._debug = false;
        this._storedCookies = new typescript_collections_1.Dictionary();
        this.EXPIRE_DATE = new Date(1970, 1);
        CookieStorage.FUTURE_DATE = new Date(2050, 1);
        this.readAllValues();
    }
    Object.defineProperty(CookieStorage, "NEVER_EXPIRE_DATE", {
        get: function () {
            return this.FUTURE_DATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CookieStorage.prototype, "hasUserData", {
        get: function () {
            var keys = this._storedCookies.keys();
            return keys.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CookieStorage.prototype, "debug", {
        set: function (pValue) {
            this._debug = pValue;
        },
        enumerable: false,
        configurable: true
    });
    //#region Bool Storage
    /**
     * Stores a Bool
     * @param pID The ID to store the bool
     * @param pValue The stored bool value
     * @param pExpiryDate The expiry date at which this saved data will be deleted
     */
    CookieStorage.prototype.storeBool = function (pID, pValue, pExpiryDate) {
        var value = pValue ? "true" : "false";
        this.log("STORING BOOL: %s at value: %s", pID, value);
        this.storeValue(pID, value, pExpiryDate);
    };
    /**
     * Reads a Bool
     * @param pID The ID to read the bool
     * @param pDefault The default value of the returned bool
     * @param returns Returns the stored bool if it can find it. If not, will return pDefault
     */
    CookieStorage.prototype.readBool = function (pID, pDefault) {
        if (pDefault === void 0) { pDefault = false; }
        var storedBool = this._storedCookies.getValue(pID);
        if (storedBool !== undefined) {
            var boolValue = storedBool === "true" ? true : false;
            return boolValue;
        }
        return pDefault;
    };
    //#endregion
    //#region Number Storage
    /**
     * Stores a Number
     * @param pID The ID to store the number
     * @param pValue The stored number value
     * @param pExpiryDate The expiry date at which this saved data will be deleted
     */
    CookieStorage.prototype.storeNumber = function (pID, pValue, pExpiryDate) {
        var value = pValue.toString();
        this.log("STORING NUMBER: %s at value: %s", pID, value);
        this.storeValue(pID, value, pExpiryDate);
    };
    /**
     * Reads a Number
     * @param pID The ID to read the number
     * @param pDefault The default value of the returned number
     * @param returns Returns the stored number if it can find it. If not, will return pDefault
     */
    CookieStorage.prototype.readNumber = function (pID, pDefault) {
        if (pDefault === void 0) { pDefault = 0; }
        var stringValue = this._storedCookies.getValue(pID);
        if (stringValue !== undefined) {
            var value = +stringValue;
            return value;
        }
        return pDefault;
    };
    //#endregion
    //#region String Storage
    /**
     * Stores a String
     * @param pID The ID to store the string
     * @param pValue The stored string value
     * @param pExpiryDate The expiry date at which this saved data will be deleted
     */
    CookieStorage.prototype.storeString = function (pID, pValue, pExpiryDate) {
        this.log("STORING STRING: %s at value: %s", pID, pValue);
        this.storeValue(pID, pValue, pExpiryDate);
    };
    /**
     * Reads a String
     * @param pID The ID to read the string
     * @param pDefault The default value of the returned string
     * @param returns Returns the stored string if it can find it. If not, will return pDefault
     */
    CookieStorage.prototype.readString = function (pID, pDefault) {
        if (pDefault === void 0) { pDefault = ""; }
        var stringValue = this._storedCookies.getValue(pID);
        if (stringValue !== undefined) {
            return stringValue;
        }
        return pDefault;
    };
    //#endregion
    CookieStorage.prototype.deleteItem = function (pID) {
        var value = this._storedCookies.getValue(pID);
        if (value !== undefined) {
            this.storeValue(pID, value, this.EXPIRE_DATE);
            this._storedCookies.remove(pID);
        }
    };
    /**
     * Prints all values stored in cookies
     */
    CookieStorage.prototype.printAll = function () {
        this._storedCookies.forEach(function (pKey, pValue) {
            Utils_1.LogUtils.log("Key: %s | Value: %s", { className: "CookieManager", color: "blue" }, pKey, pValue);
        });
    };
    /**
     * Sets the Expiration date of a cookie
     * @param pID The ID of the cookie
     * @param pExpiryDate The expiry date at which this saved data will be deleted
     */
    CookieStorage.prototype.setCookieExpiration = function (pID, pExpiryDate) {
        var value = this.readString(pID);
        if (value !== undefined) {
            this.storeValue(pID, value, pExpiryDate);
        }
        else {
            Utils_1.LogUtils.logError("Trying to set expiration date of ID: %s when it doesn't exist!", { className: "CookieManager", color: "red" }, pID);
        }
    };
    /**
     * Deletes all data saved in the cookies
     */
    CookieStorage.prototype.deleteAllData = function () {
        var _this = this;
        this._storedCookies.forEach(function (pID) {
            _this.deleteItem(pID);
        });
        this._storedCookies.clear();
    };
    /**
     * stores a value
     * @param pID The ID to store
     * @param pValue The value to store
     * @param pExpiryDate The expiry date at which this saved data will be deleted
     */
    CookieStorage.prototype.storeValue = function (pID, pValue, pExpiryDate) {
        this._storedCookies.setValue(pID, pValue);
        var cookie = pID + "=" + pValue;
        if (pExpiryDate !== undefined) {
            cookie += ";expires=" + pExpiryDate.toUTCString();
        }
        if (Utils_1.PlatformUtils.isHTTPS()) {
            cookie += ";secure";
        }
        cookie += ";samesite=lax";
        cookie += ";path=/";
        document.cookie = cookie;
    };
    CookieStorage.prototype.readAllValues = function () {
        var fullData = decodeURIComponent(document.cookie);
        var data = fullData.split(";");
        var splitData;
        for (var i = 0; i < data.length; ++i) {
            splitData = data[i].split("=");
            if (splitData.length < 2) {
                continue;
            }
            var key = splitData[0].trim();
            var value = splitData[1];
            this._storedCookies.setValue(key, value);
        }
    };
    CookieStorage.prototype.log = function (pText) {
        var pParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            pParams[_i - 1] = arguments[_i];
        }
        if (this._debug) {
            Utils_1.LogUtils.log.apply(Utils_1.LogUtils, __spreadArrays([pText, { className: "CookieStorage", color: "orange" }], pParams));
        }
    };
    return CookieStorage;
}());
exports.CookieStorage = CookieStorage;
//# sourceMappingURL=CookieStorage.js.map